import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ProximoBoletimItem {
  contrato_id: string;
  planilha_item_id: string;
  codigo_item: string;
  item_descricao: string;
  unidade: string;
  preco_unitario: number;
  qtd_execucoes: number;
  quantidade_disponivel: number;
  valor_disponivel: number;
  execucao_mais_antiga: string;
  defasagem_dias_max: number;
}

export function useProximoBoletim(contratoId: string) {
  return useQuery({
    queryKey: ['emp-proximo-boletim', contratoId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('emp_vw_proximo_boletim' as any)
        .select('*')
        .eq('contrato_id', contratoId);
      if (error) throw error;
      return (data as unknown as ProximoBoletimItem[]) ?? [];
    },
    enabled: !!contratoId,
  });
}
